import { db } from './firebaseConfig';
import { ref, get } from 'firebase/database';

/**
 * Universal ID generator for the platform.
 * Formats: [PREFIX]-DVT-XXXXXX (e.g., SUID-DVT-K82A1P, SID-DVT-81KPL2)
 * 
 * @param {string} prefix The identifier type SUID, UID, SID, AID, PID, EID, MSG, LOG
 * @param {string} collectionPath The realtime database node path to check for collisions
 * @param {string} searchKey The property key to check inside the snapshot
 * @returns {Promise<string>} A globally unique identifier string
 */
export const generateId = async (prefix, collectionPath, searchKey) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let isUnique = false;
  let newId = "";

  while (!isUnique) {
    newId = `${prefix}-DVT-`;
    for (let i = 0; i < 6; i++) {
      newId += chars[Math.floor(Math.random() * chars.length)];
    }

    // Skip collision check if no path is provided (like LOG or SID where volume is too high to scan)
    if (!collectionPath) {
      return newId;
    }

    // Check collision in DB
    const dbRef = ref(db, collectionPath);
    const snapshot = await get(dbRef);
    let collision = false;
    
    if (snapshot.exists()) {
      const dataSet = snapshot.val();
      for (const key in dataSet) {
        // Handle searching flat values or nested properties
        if (searchKey) {
            if (dataSet[key][searchKey] === newId) {
                collision = true;
                break;
            }
        } else {
            // E.g. looking at keys
            if (key === newId) {
                collision = true;
                break;
            }
        }
      }
    }

    if (!collision) isUnique = true;
  }
  
  return newId;
};
